import { IconProps } from "@assets";

const Headset = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg
            height="30"
            strokeMiterlimit="10"
            version="1.1"
            viewBox="0 0 30 30"
            width="30"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="1">
                <g opacity="1">
                    <path
                        d="M29.4674 11.1236C31.6074 19.1256 26.8574 27.3506 18.8574 29.4946C10.8574 31.6386 2.63744 26.8896 0.487419 18.8876C-1.6526 10.8856 3.0974 2.6606 11.0974 0.516621C19.0974-1.62742 27.3274 3.1216 29.4674 11.1236Z"
                        fill="#d7e3f5"
                        fillRule="nonzero"
                        opacity="1"
                        stroke="none"
                    />
                    <path
                        d="M8.03747 14.0616C8.03747 10.1956 11.1675 7.0616 15.0375 7.0616C18.8975 7.0616 22.0375 10.1956 22.0375 14.0616L22.0375 19.5056C22.0375 20.7966 20.9974 21.8386 19.6974 21.8386L17.3674 21.8386L17.3674 15.6166L20.4774 15.6166L20.4774 14.0616C20.4774 11.0516 18.0475 8.6166 15.0375 8.6166C12.0275 8.6166 9.58739 11.0516 9.58739 14.0616L9.58739 15.6166L12.6974 15.6166L12.6974 21.8386L10.3674 21.8386C9.07739 21.8386 8.03747 20.7966 8.03747 19.5056L8.03747 14.0616ZM11.1475 17.1726L11.1475 20.2836L10.3674 20.2836C9.93737 20.2836 9.58739 19.9336 9.58739 19.5056L9.58739 17.1726L11.1475 17.1726ZM20.4774 17.1726L20.4774 19.5056C20.4774 19.9336 20.1274 20.2836 19.6974 20.2836L18.9275 20.2836L18.9275 17.1726L20.4774 17.1726Z"
                        fill="#22518f"
                        fillRule="evenodd"
                        opacity="1"
                        stroke="none"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Headset;
